import { OrganizationPayload } from '_api/types';

const DefaultNewOrganization: OrganizationPayload = {
  name: '',
  phoneNumber: '',
  streetAddress: '',
  city: '',
  state: '',
  zipCode: '',
  status: 'ACTIVE',
};

export default DefaultNewOrganization;
